import feathersClient from '../../feathers-client';

export default {
	namespaced: true,
	state: {
		autoAcceptanceTimer: [],
	},
	getters: {

	},
	mutations: {
		SET_AUTO_ACCEPTANCE_TIMER: (state, offer) => { state.autoAcceptanceTimer = offer; },
	},
	actions: {
		getAutoAcceptanceTimer: async ({ rootGetters, commit }, id) => {
			const results = await feathersClient.service('/api/v3/trust-configurations').find({
				query: {
					$role: rootGetters.currentUserRole,
					trustId: id,
				},
			});
			if (results.data.length === 0) {
				const obj = {
					isEnabled: false,
					duration: 0,
				};
				results.data.push(obj);
			}
			commit('SET_AUTO_ACCEPTANCE_TIMER', results.data);
			return results.data;
		},
		updateAutoAcceptanceTimer: async ({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/trust-configurations').patch(data.id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},

		getAutoAcceptanceTimerById: async ({ rootGetters }, id) => {
			const results = await feathersClient.service('/api/v3/trust-configurations').find({
				query: {
					$role: rootGetters.currentUserRole,
					trustId: id,
				},
			});

			return results;
		},
		createAutoAcceptanceTimer: async ({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/trust-configurations').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},

	},
};
